import { useParams, useLocation } from 'react-router-dom';
import { VoucherProvider } from '../../context/VoucherProdiver';
import { CreationSuccess } from '../../components/CreationSuccess';
import { Voucher } from '../../types/Voucher';

const SuccessPage = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const voucher = (state as { voucher?: Voucher } | null)?.voucher;

  if (!id) return null;

  return (
    <VoucherProvider id={id} initialData={voucher}>
      <CreationSuccess />
    </VoucherProvider>
  );
};

export default SuccessPage;
